import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link,
  Divider,
} from '@mui/material';
import {
  Email,
  Phone,
  LocationOn,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import hfssLogo from '../assets/hfss_logo.png';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ backgroundColor: '#1a1a1a', color: 'white', pt: 8, pb: 4 }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              md: 'repeat(12, 1fr)',
            },
            gap: 4,
          }}
        >
          {/* Company Info */}
          <Box sx={{ gridColumn: { xs: '1', md: 'span 4' } }}>
            <Box sx={{ mb: 3 }}>
              <img 
                src={hfssLogo} 
                alt="HFSS" 
                style={{ height: 60, marginBottom: 16 }}
              />
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                HFSS - HikeAndFly Software Solutions
              </Typography>
              <Typography variant="body2" sx={{ mb: 2, color: 'rgba(255,255,255,0.7)' }}>
                {t('landing.footer.tagline')}
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                {t('landing.footer.copyright')}
              </Typography>
            </Box>
          </Box>

          {/* Products */}
          <Box sx={{ gridColumn: { xs: '1', sm: 'span 6', md: 'span 2' } }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              {t('landing.footer.products')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                href="https://www.hikeandfly.app"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  '&:hover': { color: '#3388ff' }
                }}
              >
                HikeAndFly App
              </Link>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#3388ff',
                  fontWeight: 500
                }}
              >
                HFSS Clubs Management
              </Typography>
            </Box>
          </Box>

          {/* Contact */}
          <Box sx={{ gridColumn: { xs: '1', md: 'span 4' } }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              {t('landing.footer.contact')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Email sx={{ fontSize: 20, color: '#3388ff' }} />
                <Link
                  href="mailto:info@hikeandfly.app"
                  sx={{ 
                    color: 'rgba(255,255,255,0.7)', 
                    textDecoration: 'none',
                    '&:hover': { color: '#3388ff' }
                  }}
                >
                  info@hikeandfly.app
                </Link>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone sx={{ fontSize: 20, color: '#3388ff' }} />
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                  +41 76 8050877
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <LocationOn sx={{ fontSize: 20, color: '#3388ff', mt: 0.5 }} />
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                  {t('landing.footer.switzerland')}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.1)' }} />
        
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 2
        }}>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.5)' }}>
            Made with ❤️ for the flying community
          </Typography>
          <Box sx={{ display: 'flex', gap: 3 }}>
            <Link
              href="https://www.hikeandfly.app/privacy"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ 
                color: 'rgba(255,255,255,0.5)', 
                textDecoration: 'none',
                fontSize: '0.875rem',
                '&:hover': { color: '#3388ff' }
              }}
            >
              Privacy Policy
            </Link>
            <Link
              href="https://www.hikeandfly.app/terms"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ 
                color: 'rgba(255,255,255,0.5)', 
                textDecoration: 'none',
                fontSize: '0.875rem',
                '&:hover': { color: '#3388ff' }
              }}
            >
              Terms of Service
            </Link>
            <Link
              href="/service-addendum"
              sx={{ 
                color: 'rgba(255,255,255,0.5)', 
                textDecoration: 'none',
                fontSize: '0.875rem',
                '&:hover': { color: '#3388ff' }
              }}
            >
              Service Addendum
            </Link>
            <Link
              href="/club-agreement"
              sx={{ 
                color: 'rgba(255,255,255,0.5)', 
                textDecoration: 'none',
                fontSize: '0.875rem',
                '&:hover': { color: '#3388ff' }
              }}
            >
              Club Agreement
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;